/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardApprenantNonInscritsDto } from './DashboardApprenantNonInscritsDto';
import {
    DashboardApprenantNonInscritsDtoFromJSON,
    DashboardApprenantNonInscritsDtoFromJSONTyped,
    DashboardApprenantNonInscritsDtoToJSON,
} from './DashboardApprenantNonInscritsDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardApprenantNonInscritsDtoPaginatedResults
 */
export interface DashboardApprenantNonInscritsDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardApprenantNonInscritsDto>}
     * @memberof DashboardApprenantNonInscritsDtoPaginatedResults
     */
    results?: Array<DashboardApprenantNonInscritsDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardApprenantNonInscritsDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardApprenantNonInscritsDtoPaginatedResults interface.
 */
export function instanceOfDashboardApprenantNonInscritsDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardApprenantNonInscritsDtoPaginatedResultsFromJSON(json: any): DashboardApprenantNonInscritsDtoPaginatedResults {
    return DashboardApprenantNonInscritsDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardApprenantNonInscritsDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardApprenantNonInscritsDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardApprenantNonInscritsDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardApprenantNonInscritsDtoPaginatedResultsToJSON(value?: DashboardApprenantNonInscritsDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardApprenantNonInscritsDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

